import clsx from 'clsx';
import { ProgressBar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import HTooltip from '../../../../_mesomb/partials/components/HTooltip.tsx';
import { FundModel } from '../../../../types';

function FundTarget({
  fund,
  className,
}: {
  fund: FundModel;
  className?: string;
}) {
  const { t } = useTranslation();
  const progress =
    (fund.target ?? 0) > 0
      ? (fund.collected_amount * 100) / fund.target!
      : undefined;
  return (
    <div className={clsx('d-flex align-items-center flex-column', className)}>
      <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
        <span className='fw-semibold fs-6 text-gray-400'>{t('Target')}</span>
        <span className='fw-bold fs-6'>
          {t('intlCurrency', {
            value: fund.target,
            currency: fund.currency,
          })}
        </span>
      </div>
      <div className='h-20px w-100 bg-light mb-3'>
        {progress && (
          <HTooltip title={t('Fund_progression_info', { progress })}>
            <div className='h-20px w-100 bg-light-success rounded'>
              <ProgressBar
                now={progress}
                min={0}
                max={100}
                variant={'success'}
                label={`${t('intlNumber', { value: progress })} %`}
                style={{ height: 20 }}
              />
            </div>
          </HTooltip>
        )}
      </div>
    </div>
  );
}

export default FundTarget;
